import { WorkspaceView, WorkspaceViewGroup, WorkspaceViewRepresentation } from '../../types/WorkspaceView';
import { Column } from '../../types/WorkspaceViewColumn';

/** Stable synthetic view id — uses storageKey namespace so it never collides with real view ids. */
export const ALL_TASKS_VIEW_ID = 0;
export const ALL_TASKS_STORAGE_KEY = 'all-tasks-expanded';

/**
 * Synthetic WorkspaceView fed to ViewContext when rendering the All Tasks table.
 * - group: backlog → retains the Stage (sprintStatus) column (not dropped for sprint/kanban groups)
 * - columns.order: fixed superset matching the PRD default new-space property order
 * - Per-row cells still render framework-specifically via RowWorkspaceData.framework
 */
export const allTasksSyntheticView: WorkspaceView = {
  id: ALL_TASKS_VIEW_ID,
  publicId: 'all-tasks',
  name: 'All Tasks',
  workspaceId: 0,
  group: WorkspaceViewGroup.backlog,
  representation: WorkspaceViewRepresentation.table,
  entityType: undefined as any,
  groupBy: undefined,
  sortBy: undefined,
  filters: undefined,
  columns: {
    hidden: [],
    order: [
      Column.subitems,
      Column.epic,
      Column.sprintStatus,
      Column.label,
      Column.assignee,
      Column.status,
      Column.startDate,
      Column.deadline,
      Column.priority,
      Column.estimate,
    ],
  },
  orderIndex: undefined,
  default: undefined,
  createdAt: new Date(0),
  updatedAt: new Date(0),
};
